import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { map } from 'rxjs/operators';
import { ToastContainerDirective } from 'ngx-toastr';
import { AtlasGridComponent } from '../../../ui/components/atlas-grid/atlas-grid.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PasswordType, Subaccount } from '@models/subaccount/subaccount';
import { SubaccountService } from '@services/subaccount.service';
import { ResellerService } from '@services/reseller.service';
import { AtlasToastService } from '@services/atlas-toast.service';
import { UserService } from '@services/user.service';
import { User } from '@models/user';
import { Location } from '@angular/common';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { checkPassword, checkValidSender } from '@utils/validators';
import { MenuService } from '@services/menu.service';
import { SMS_SENDERS } from '@models/menu-entries';
import { Subscription } from 'rxjs';
import { Domain } from '@models/domain';
import { LoaderService } from '@services/loader.service';
import { DomainService } from '@services/domain.service';
import { LoginService } from 'src/app/core/login/login.service';

function noWhitespaceValidator(): (AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value.toString() !== null) {
      if (/\s/.test(control.value.toString())) {
        return { noWhitespace: true };
      }
    }
  };
}

// function checkUsername(compareTo?: string): (AbstractControl) => ValidationErrors | null {
//   return (control: AbstractControl): ValidationErrors | null => {
//     const patternAuth = /[a-zA-Z0-9._@+#!$'`^~-]+$/;
//     if (!control.value.match(patternAuth)) {
//       return { BadUsername: true };
//     }
//     return null;
//   };
// }

@Component({
  selector: 'wsb-subaccount-detail',
  templateUrl: './subaccount-detail.component.html',
  styleUrls: ['./subaccount-detail.component.scss'],
  standalone: false
})
export class SubaccountDetailComponent implements OnInit, AfterViewChecked {
  @ViewChild(AtlasGridComponent) grid: AtlasGridComponent;
  @ViewChild('page', { static: true }) $page;
  @ViewChild('modalTemplate', { static: true }) modalTemplate;
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;
  @ViewChild('submitBtn', { static: true }) $submitBtn;
  @ViewChild('modalForceOverWrite') modalForceOverWrite;
  @ViewChild('modalChangePassword') modalChangePassword;
  @ViewChild('modalChangeApiPassword') modalChangeApiPassword;
  $actionsBar: ElementRef;
  @ViewChild('actionsBar', { static: false }) set content(content: ElementRef) {
    if (content) {
      this.$actionsBar = content;
    }
  }

  modalForceOverWriteModal: NgbModalRef;
  modalChangePasswordModal: NgbModalRef;
  modalChangeApiPasswordModal: NgbModalRef;

  selectionChanged = false;

  paginationPageSize = 10;

  profiles: Array<{ id: number; value: string }> = [];

  languages: Array<{ id: string; value: string }> = [
    { id: 'eng', value: 'English' },
    { id: 'fra', value: 'French' },
    { id: 'deu', value: 'German' },
    { id: 'ita', value: 'Italian' },
    { id: 'esp', value: 'Spanish' }
  ];

  user: User;
  subaccountForm: UntypedFormGroup = null;
  subaccount: any;

  isSenderLock: boolean;
  editing = false;
  id = null;
  overWriteId = null;

  passwordCheck: string;
  passwordApiCheck: string;
  newPassword: UntypedFormControl = new UntypedFormControl('', [checkPassword(), Validators.maxLength(16)]);
  newApiPassword: UntypedFormControl = new UntypedFormControl('', [checkPassword(), Validators.maxLength(16)]);

  isEmptyPasswordForm = false;
  passwordApiOption = true;

  faPasswordOldIconShow = faEye;
  showPasswordOld = false;
  faPasswordNewIconShow = faEye;
  faPasswordApiIconShow = faEye;
  showPasswordNew = false;
  showPasswordApi = false;
  faPasswordRepeatIconShow = faEye;
  faPasswordApiRepeatIconShow = faEye;
  showPasswordRepeat = false;
  showPasswordApiRepeat = false;
  menuEntries;
  showDefaultSender = true;
  isEditResellerSubaccount: boolean;
  domainSubscription: Subscription;
  domain: Domain | null;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private elRef: ElementRef,
    private atlasToast: AtlasToastService,
    private userService: UserService,
    private resellerService: ResellerService,
    private modalService: NgbModal,
    private subaccountService: SubaccountService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private menuService: MenuService,
    private domainService: DomainService,
    private loaderService: LoaderService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.editing = this.router.url.split('?')[0] === '/reseller/subaccounts-settings';
    window.addEventListener('scroll', this.scroll, true);
    this.loaderService.show();
    this.domainSubscription = this.domainService.getDomainState().subscribe(x => {
      this.domain = x;
      this.loaderService.hide();
    });
    this.menuService.getMenuEntriesState().subscribe(entries => {
      this.menuEntries = entries;
      if (this.menuEntries[SMS_SENDERS]) {
        this.showDefaultSender = false;
      }
    });

    this.route.queryParams.subscribe(query => {
      this.id = query.id;
    });

    this.subaccountForm = this.formBuilder.group({
      idSubaccountProfile: [],
      login: [''], // PWSB-2363 For new subaccount the login is the registration email
      password: [''],
      passwordApi: [''],
      isSuperaccount: [false],

      attribute: this.formBuilder.group({
        name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(49)]],
        surname: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(49)]],
        email: ['', [Validators.required, Validators.email]],
        mobile: ['', [Validators.required, Validators.pattern(/^(\+)?[0-9]{5,15}$/)]],
        companyName: ['', Validators.required],
        vat: [''],
        fiscalCode: [''],
        address: [''],
        zipCode: [''],
        city: [''],
        province: [''],
        phone: ['', Validators.pattern(/^(\+)?[0-9]{5,15}$/)],
        fax: ['', Validators.pattern(/^(\+)?[0-9]{5,15}$/)],
        invoicingEmail: ['', Validators.email]
      }),

      options: this.formBuilder.group({
        idLanguage: ['', Validators.required],
        dfeu: [true, Validators.required],
        use24: [true, Validators.required]
      }),

      defaultSender: this.formBuilder.group({
        defaultSender: ['', checkValidSender()],
        isSenderLock: [false]
      })
    });

    this.userService.getAuthenticationState().subscribe(loggedUser => {
      this.user = loggedUser;
      this.subaccountForm.get('options.idLanguage').patchValue(loggedUser.preferences.language);
    });
    this.resellerService.getProfiles().subscribe(profiles => {
      for (const profile of profiles.data) {
        this.profiles = [
          ...this.profiles,
          {
            id: profile.idSubaccountProfile,
            value: profile.name
          }
        ];
      }
      if (this.editing && this.id) {
        // new
        this.subaccountService
          .getSubaccount(this.id)
          .pipe(
            map(sub => {
              // For old tax codes with a lowercase letter
              sub.attribute.fiscalCode = sub.attribute.fiscalCode ? sub.attribute.fiscalCode.toUpperCase() : '';
              return sub;
            })
          )
          .subscribe(sub => {
            this.subaccount = sub;
            this.subaccountForm.patchValue(sub);
            this.isEditResellerSubaccount = sub.isSuperaccount;
          });
      } else {
        this.subaccountForm.get('idSubaccountProfile').patchValue(this.profiles[0]?.id);
        this.subaccountForm.get('password').setValidators([checkPassword()]);
        this.subaccountForm.get('password').updateValueAndValidity();
      }
    });

    if (!this.editing) {
      this.subaccountForm.controls.login.setValidators([Validators.required, Validators.email]);
      this.subaccountForm.controls.login.updateValueAndValidity();
      this.subaccountForm.controls.password.setValidators([Validators.required, checkPassword(), noWhitespaceValidator()]);
      this.subaccountForm.controls.password.updateValueAndValidity();
      this.passwordFormValueChange();
      this.passwordApiFormValueChange();
    }
  }

  private passwordFormValueChange() {
    this.subaccountForm.controls.password.valueChanges.subscribe(pwd => {
      this.isEmptyPasswordForm = pwd.length > 0 ? false : true;
    });
  }

  private passwordApiFormValueChange() {
    this.subaccountForm.controls.passwordApi.valueChanges.subscribe(api => {
      if (api !== '' && api !== undefined) {
        this.passwordApiOption = this.verifyValidationApiPassword(api);
      } else {
        this.passwordApiOption = true;
      }
    });
  }

  private verifyValidationApiPassword(api) {
    const patternAuth = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%.^&*]).{8,}$/;
    if (!api.match(patternAuth)) {
      return false;
    }
    return true;
  }

  customValidationFunction(formGroup): any {
    const emailField = formGroup.controls.email ? formGroup.controls.email.value : 0;
    const phoneField = formGroup.controls.phone.value;
    return formGroup.controls.email && !emailField && !phoneField ? { oneOfEmailPhone: true } : null;
  }

  ngAfterViewChecked(): void {
    this.displayScrollIndicator();
  }

  scroll = (): void => {
    this.displayScrollIndicator();
  };

  displayScrollIndicator() {
    if (!(this.$page && this.$actionsBar)) {
      return;
    }

    const $pageProfile: HTMLElement = this.$page.nativeElement;
    const $actionsBar: HTMLElement = this.$actionsBar.nativeElement;
    const $impersonateHeader: HTMLElement = document.getElementById('impersonate-header');

    if (!this.elRef.nativeElement || !this.elRef.nativeElement.closest('body')) {
      return;
    }

    const remainingHeight = window.innerHeight - $pageProfile.getBoundingClientRect().top;

    if (
      $pageProfile.clientHeight > remainingHeight + 5 &&
      $pageProfile.getBoundingClientRect().bottom - window.innerHeight - $impersonateHeader.getBoundingClientRect().bottom > 50
    ) {
      $actionsBar.classList.add('has--scroll-indicator');
    } else {
      $actionsBar.classList.remove('has--scroll-indicator');
    }
  }

  onSelectionChange(numSelected) {
    this.selectionChanged = true;
  }

  showHidePassWordNew() {
    this.showPasswordNew = !this.showPasswordNew;
    if (this.showPasswordNew) {
      this.faPasswordNewIconShow = faEyeSlash;
    } else {
      this.faPasswordNewIconShow = faEye;
    }
  }

  showHidePassWordApiNew() {
    this.showPasswordApi = !this.showPasswordApi;
    if (this.showPasswordApi) {
      this.faPasswordApiIconShow = faEyeSlash;
    } else {
      this.faPasswordApiIconShow = faEye;
    }
  }

  stampForm() {
    // console.log(this.subaccountForm);
  }

  showHidePassWordRepeat() {
    this.showPasswordRepeat = !this.showPasswordRepeat;
    if (this.showPasswordRepeat) {
      this.faPasswordRepeatIconShow = faEyeSlash;
    } else {
      this.faPasswordRepeatIconShow = faEye;
    }
  }

  showHidePassWordApiRepeat() {
    this.showPasswordApiRepeat = !this.showPasswordApiRepeat;
    if (this.showPasswordApiRepeat) {
      this.faPasswordApiRepeatIconShow = faEyeSlash;
    } else {
      this.faPasswordApiRepeatIconShow = faEye;
    }
  }

  save() {
    if (this.editing) {
      const patch = this.buildPatchRequest();
      this.subaccountService.editSubaccount(this.id, patch).subscribe(
        success => {
          this.atlasToast.success('common_success', null, 6000, this.toastContainer);
          this.goBack();
        },
        error => {
          this.atlasToast.error('common_error', null, 6000, this.toastContainer);
        }
      );
    } else {
      const sub: Subaccount = this.subaccountForm.value;
      this.subaccountService.addSubaccount(sub).subscribe(
        success => {
          this.atlasToast.success('common_success', null, 6000, this.toastContainer);
          this.goBack();
        },
        // "Login: asdadasdsad, dns: nullis already present"
        error => {
          if (error.error.error_message === 'Registration email already in use') {
            this.atlasToast.error('register_error_duplicateemail', null, 6000, this.toastContainer);
          } else if (error.error.error_message === 'Username already used') {
            this.atlasToast.error('register_error_duplicateusername', null, 6000, this.toastContainer);
          } else {
            this.atlasToast.error('common_error', null, 6000, this.toastContainer);
          }
        }
      );
    }
  }

  buildPatchRequest() {
    const patches = [];
    for (const field in this.subaccountForm.controls) {
      if (field === 'attribute' || field === 'options') {
        for (const detail in this.subaccountForm.get(field).value) {
          if (detail) {
            const value = this.subaccountForm.get(field + '.' + detail).value;
            const patch = { op: 'replace', path: '/' + field + '/' + detail, value };
            patches.push(patch);
          }
        }
      } else {
        if (this.menuEntries[SMS_SENDERS]) {
          if (field !== 'password' && field !== 'login' && field !== 'defaultSender' && field !== 'passwordApi') {
            const value = this.subaccountForm.get(field).value;
            const patch = {
              op: 'replace',
              path: '/' + field,
              value
            };
            patches.push(patch);
          }
        } else {
          if (field === 'defaultSender') {
            for (const detail in this.subaccountForm.get(field).value) {
              if (detail) {
                const value = this.subaccountForm.get(field + '.' + detail).value;
                const patch = { op: 'replace', path: '/' + field + '/' + detail, value };
                patches.push(patch);
              }
            }
          }
          if (field !== 'password' && field !== 'login' && field !== 'defaultSender' && field !== 'passwordApi') {
            const value = this.subaccountForm.get(field).value;
            const patch = {
              op: 'replace',
              path: '/' + field,
              value
            };
            patches.push(patch);
          }
        }
      }
    }
    // console.log(patches);
    return patches;
  }

  openModalChangPassword(): void {
    this.modalChangePasswordModal = this.modalService.open(this.modalChangePassword);
    this.modalChangePasswordModal.result.then(
      result => {},
      reason => {
        this.closeModal();
      }
    );
  }

  openModalChangPasswordApi(): void {
    this.modalChangeApiPasswordModal = this.modalService.open(this.modalChangeApiPassword);
    this.modalChangeApiPasswordModal.result.then(
      result => {},
      reason => {
        this.closeModalPasswordApi();
      }
    );
  }

  saveNewPassword() {
    this.subaccountService.editSubaccountPassword(this.id, this.passwordCheck, PasswordType.WEBAPP).subscribe(
      success => {
        this.atlasToast.success('common_success', null, 6000, this.toastContainer);
        this.closeModal();
      },
      error => {
        // this.atlasToast.error('common_error', null, 6000, this.toastContainer);
        this.atlasToast.openToast(
          'common_error',
          null,
          error.error?.error_message ? error.error?.error_message : null,
          6000,
          'error',
          this.toastContainer
        );
      }
    );
  }

  saveNewPasswordApi() {
    this.subaccountService.editSubaccountPassword(this.id, this.passwordApiCheck, PasswordType.API).subscribe(
      success => {
        this.atlasToast.success('common_success', null, 6000, this.toastContainer);
        this.closeModalPasswordApi();
      },
      error => {
        // this.atlasToast.error('common_error', null, 6000, this.toastContainer);
        this.atlasToast.openToast(
          'common_error',
          null,
          error.error?.error_message ? error.error?.error_message : null,
          6000,
          'error',
          this.toastContainer
        );
      }
    );
  }

  closeModalPasswordApi() {
    this.modalChangeApiPasswordModal.close();
    this.newApiPassword.reset();
    this.passwordApiCheck = undefined;
    this.faPasswordApiRepeatIconShow = faEye;
  }

  closeModal() {
    this.modalChangePasswordModal.close();
    this.newPassword.reset();
    this.passwordCheck = undefined;
    this.faPasswordRepeatIconShow = faEye;
  }

  goBack() {
    this.location.back();
  }

  modalForceOverWriteSubmit() {
    this.editing = true;
    this.id = this.overWriteId;
    this.modalForceOverWriteModal.close();
  }

  resetForm() {
    this.subaccountForm.reset(this.subaccount);
  }

  isDisableResellerSubaccount() {
    if (this.editing === true) {
      if (this.isEditResellerSubaccount === true) {
        return this.subaccountForm.controls.isSuperaccount.value;
      }
    }
    return false;
  }

  isUniversalLogin() {
    return this.loginService.isUniversalLogin();
  }
}
